export default [
    {
        path: '/landings',
        name: 'PageLandingsList',
        meta: { title: 'landings.listTitle', roles: ['ADMIN'], permissions: ['landing_view'] },
        component: () => import('@/pages/landings'),
    },
    {
        path: '/landings/create',
        name: 'PageLandingsCreate',
        meta: { title: 'landings.createFormTitle', roles: ['ADMIN'], permissions: ['landing_view'] },
        component: () => import('@/pages/landings/create'),
    },
    {
        path: '/landings/:id/edit',
        name: 'PageLandingsEdit',
        meta: { title: 'landings.editFormTitle', roles: ['ADMIN'], permissions: ['landing_view'] },
        component: () => import('@/pages/landings/id/edit'),
    },
]
